import { render } from "./TestimonialNavigation.vue?vue&type=template&id=3c4054b0"
import script from "./TestimonialNavigation.vue?vue&type=script&lang=js"
export * from "./TestimonialNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/pro/Components/TestimonialNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c4054b0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c4054b0', __exports__)) {
    api.reload('3c4054b0', __exports__)
  }
  
  module.hot.accept("./TestimonialNavigation.vue?vue&type=template&id=3c4054b0", () => {
    api.rerender('3c4054b0', render)
  })

}


export default __exports__